var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meeting-filter" },
    [
      _c(
        "portal-filter-bar",
        { attrs: { label: _vm.$t("meetings.filter.heading") } },
        [
          _c("portal-search-field", {
            attrs: {
              value: _vm.filter.search || "",
              label: _vm.$t("meetings.filter.heading"),
              placeholder: _vm.$t("global.filter"),
              "clear-label": _vm.$t("global.clear")
            },
            on: { input: _vm.updateSearch }
          }),
          _c("portal-select-field", {
            attrs: {
              "field-class": "status-filter",
              value: _vm.meetingStatusValue,
              label: _vm.$t("meetings.filter.meeting-status"),
              options: _vm.meetingStatusOptions
            },
            on: { input: _vm.updateMeetingStatus }
          }),
          _c("portal-select-field", {
            attrs: {
              "field-class": "date-filter",
              value: _vm.filter.dateSpecifier || "",
              label: _vm.$t("meetings.filter.date-range"),
              options: _vm.dateOptions
            },
            on: { input: _vm.updateDateSpecifier }
          })
        ],
        1
      ),
      _vm.filter.dateSpecifier === "between"
        ? _c("div", { staticClass: "custom-date-range" }, [
            _c(
              "div",
              { staticClass: "custom-date-field" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("meetings.filter.earliest")))
                ]),
                _c("date-selector", {
                  attrs: {
                    date: _vm.filter.earliest,
                    label: _vm.$t("meetings.filter.earliest"),
                    panel: true
                  },
                  on: {
                    change: function($event) {
                      return _vm.updateDate("earliest", $event)
                    }
                  }
                })
              ],
              1
            ),
            _c("span", {
              staticClass: "date-divider",
              attrs: { "aria-hidden": "true" }
            }),
            _c(
              "div",
              { staticClass: "custom-date-field" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$t("meetings.filter.latest")))]),
                _c("date-selector", {
                  attrs: {
                    date: _vm.filter.latest,
                    label: _vm.$t("meetings.filter.latest"),
                    panel: true
                  },
                  on: {
                    change: function($event) {
                      return _vm.updateDate("latest", $event)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "button",
              {
                staticClass: "clear-filter",
                attrs: { type: "button" },
                on: { click: _vm.clearFilter }
              },
              [
                _c("portal-icon", { attrs: { name: "x", size: 15 } }),
                _vm._v(
                  " " + _vm._s(_vm.$t("meetings.filter.clear-filter")) + " "
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }